export default "__VITE_ASSET__BOKz5IEh__"